export default "__VITE_ASSET__226dd9cb__"